import React from 'react';

import { ThreeDStockMaterialsListItemPreviewMaterial } from './ThreeDStockMaterialsListItemPreview.types';
import { UpdateMaterialCacheAction } from '../../../../../../materials/materialsTypes';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import { ThreeDStockMaterialsListItemButtons } from '../ThreeDStockMaterialsListItemButtons';

import { Icon } from '../../../../../../../helpers/Icon';
import {
  ImageHelper,
  ImageItemImageVersions
} from '../../../../../../../helpers/ImageHelper';
import { PureIconButtonHelper } from '../../../../../../../helpers/buttons/PureIconButtonHelper';

import { Files } from '../../../../../../../utils/Files';

import { words } from '../../../../../../../locales/keys';

const srcSetVersions = {
  '1x': ImageItemImageVersions.MiniThumb320x320,
  '2x': ImageItemImageVersions.MiniThumb640x640,
  '3x': ImageItemImageVersions.MiniThumb960x960
};

interface ThreeDStockMaterialsListItemPreviewProps {
  material: ThreeDStockMaterialsListItemPreviewMaterial;
  downloadButtonAction: string;
  downloadSeparatelyButtonAction: string;
  materialEditPagePath: string;
  onLightboxOpen: () => void;
  updateMaterialCache?: UpdateMaterialCacheAction<ThreeDStockMaterialsListItemPreviewMaterial>;
  onEditButtonMouseEnter?: () => void;
}

function ThreeDStockMaterialsListItemPreview({
  material,
  downloadButtonAction,
  downloadSeparatelyButtonAction,
  onLightboxOpen,
  updateMaterialCache,
  onEditButtonMouseEnter,
  materialEditPagePath
}: ThreeDStockMaterialsListItemPreviewProps) {
  return (
    <div className="aspect-w-1 aspect-h-1 w-full bg-gray-100 dark:bg-gray-800 order-first">
      {material.image?.file && Files.isImage(material.image?.file) ? (
        <ImageHelper
          className="object-cover w-full h-full"
          src={material.image.file}
          version={ImageItemImageVersions.MiniThumb320x320}
          srcSetVersions={srcSetVersions}
          alt={material.name}
        />
      ) : (
        <div className="flex items-center justify-center text-gray-600 absolute inset-0">
          <Icon icon={IconsEnum.PHOTOGRAPH_OUTLINE} className="h-12 w-12" />
        </div>
      )}

      <div className="absolute inset-0 md:bg-black md:bg-opacity-0 pointer-events-none md:group-hover:bg-opacity-40 group-focus-within:bg-opacity-40 group-hover:pointer-events-auto group-focus-within:pointer-events-auto transition-color duration-150">
        <div className="absolute bottom-0 left-0 w-full pb-3 px-3 md:opacity-0 pointer-events-none md:group-hover:opacity-100 group-hover:pointer-events-auto md:group-focus-within:opacity-100 transition-opacity duration-150 ease-out z-[2]">
          <div>
            <ThreeDStockMaterialsListItemButtons
              material={material}
              updateMaterialCache={updateMaterialCache}
              onEditButtonMouseEnter={onEditButtonMouseEnter}
              downloadButtonAction={downloadButtonAction}
              downloadSeparatelyButtonAction={downloadSeparatelyButtonAction}
              materialEditPagePath={materialEditPagePath}
            />

            <PureIconButtonHelper
              className="bg-white text-black hover:bg-gray-100 p-2 w-full justify-center flex gap-2 items-center rounded-full mt-2 text-sm"
              iconClassName="h-5 w-5 stroke-2"
              icon={IconsEnum.ARROWS_EXPAND_OUTLINE}
              i18nTextClassName="block"
              i18nText={words.expand_view}
              onClick={onLightboxOpen}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockMaterialsListItemPreview;
